import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import EventDetails from './pages/EventDetails';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import Events from './pages/api/events';
import ArchivedEvents from './pages/ArchivedEvents';
import Navbar from './components/Navbar';
import Signup from './pages/Signup';
import About from './pages/About';
import Pricing from './pages/Pricing';
import UserPage from './pages/UserPage';
import PosterPage from './pages/PosterPage';
import BingoMachine from './pages/BingoMachine';
import BingoSchedule from './pages/BingoSchedule';
import EliminationDinner from './pages/EliminationDinner';
import BingoScanner from './components/BingoScanner';
import BingoDisplay from './pages/BingoDisplay';
import Flash from './pages/Flash';
import ProgramTemplates from './components/ProgramTemplates';
import EventReports from './pages/EventReports';

function App() {
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(
    localStorage.getItem('isAdminLoggedIn') === 'true'
  );
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);

  return (
    <div className="App">
      <Navbar
        isAdminLoggedIn={isAdminLoggedIn}
        setIsAdminLoggedIn={setIsAdminLoggedIn}
        isNavbarVisible={isNavbarVisible}
        setIsNavbarVisible={setIsNavbarVisible}
      />

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={(
            <Home
              isAdminLoggedIn={isAdminLoggedIn}
              setIsAdminLoggedIn={setIsAdminLoggedIn}
            />
          )}
        />

        {/* Event Details Page */}
        <Route path="/event/:eventCode" element={<EventDetails />} />

        {/* Admin Login Page */}
        <Route
          path="/admin-login"
          element={(
            <AdminLogin
              isAdminLoggedIn={isAdminLoggedIn}
              setIsAdminLoggedIn={setIsAdminLoggedIn}
            />
          )}
        />

        {/* Admin Dashboard */}
        <Route
          path="/admin"
          element={isAdminLoggedIn ? <AdminDashboard /> : <Navigate to="/admin-login" />}
        />

        {/* Events Management Page */}
        <Route
          path="/events"
          element={isAdminLoggedIn ? <Events /> : <Navigate to="/admin-login" />}
        />

        {/* Archived Events Page */}
        <Route
          path="/archived-events"
          element={isAdminLoggedIn ? <ArchivedEvents /> : <Navigate to="/admin-login" />}
        />

        {/* Poster Page */}
        <Route
          path="/poster"
          element={isAdminLoggedIn ? <PosterPage /> : <Navigate to="/admin-login" />}
        />

        {/* Bingo Machine Page */}
        <Route
          path="/bingo-machine"
          element={isAdminLoggedIn ? (
            <BingoMachine
              isNavbarVisible={isNavbarVisible}
              setIsNavbarVisible={setIsNavbarVisible}
            />
          ) : <Navigate to="/admin-login" />}
        />

        {/* Bingo Schedule Page */}
        <Route
          path="/bingo-schedule/:eventId"
          element={isAdminLoggedIn ? <BingoSchedule /> : <Navigate to="/admin-login" />}
        />

        <Route
          path="/program-templates"
          element={isAdminLoggedIn ? <ProgramTemplates /> : <Navigate to="/admin-login" />}
        />

        <Route
          path="/event-reports/:eventId"
          element={isAdminLoggedIn ? <EventReports /> : <Navigate to="/admin-login" />}
        />

        {/* Bingo Display Page */}
        <Route path="/bingo-display/:eventId" element={<BingoDisplay />} />

        {/* Bingo Scanner Page */}
        <Route path="/bingo-scanner/:eventId" element={<BingoScanner />} />

        {/* Elimination Dinner Page */}
        <Route
          path="/elimination-dinner"
          element={isAdminLoggedIn ? <EliminationDinner /> : <Navigate to="/admin-login" />}
        />

        {/* Signup Page */}
        <Route path="/signup" element={<Signup />} />

        {/* About Page */}
        <Route path="/about" element={<About />} />

        {/* Buzz Board Flash Page */}
        <Route path="/flash" element={<Flash />} />

        {/* Pricing Page */}
        <Route path="/pricing" element={<Pricing />} />

        {/* User Page */}
        <Route path="/user-page/:eventId" element={<UserPage />} />
      </Routes>
    </div>
  );
}

export default App;
